import React from 'react';
import { Minus, Moon, Plus, Sun } from 'lucide-react';
import { Button } from './Button';
import { PACK_DAYS, formatAED, pillCountLabel } from '../utils/pack';
import type { Pill } from '../types/platform';
type PillRowProps = {
  pill: Pill;
  reasons?: string[];
  showPrice?: boolean;
  inPack?: boolean;
  onToggle?: () => void;
};
export function PillRow({
  pill,
  reasons,
  showPrice,
  inPack,
  onToggle
}: PillRowProps) {
  const TimingIcon = pill.timing === 'Morning' ? Sun : Moon;
  return <li className={`flex items-center gap-4 rounded-xl border px-4 py-3 transition-colors ${onToggle && !inPack ? 'border-dashed border-white/10 opacity-70' : 'border-white/10 bg-white/[0.02]'}`} data-id="element-111" data-mp="3lcon9tnu2quc">
      <span className="flex w-5 shrink-0 flex-col items-center gap-0.5" aria-hidden="true" data-id="element-112" data-mp="3vacl4sgqkegq">
        {Array.from({
        length: pill.count
      }, (_, i) => <span key={i} className={pill.form === 'tablet' ? 'size-3 rounded-full' : pill.form === 'softgel' ? 'h-3 w-4 rounded-full' : 'h-2.5 w-5 rounded-full'} style={{
        backgroundColor: pill.color
      }} data-id="element-113" data-mp="20xmldu3osb1f" />)}
      </span>
      <div className="min-w-0 flex-1" data-id="element-114" data-mp="2siglp0v315dy">
        <p className="font-medium" data-id="element-115" data-mp="2nkx88367kwn2">{pill.name}</p>
        <p className="text-sm text-muted-foreground" data-id="element-116" data-mp="2nlq7kj2u8jv6">{pill.purpose}</p>
        <dl className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-xs" data-id="element-117" data-mp="2ineve1p2lx9s">
          <div className="flex gap-1" data-id="element-118" data-mp="3g9vr52i5o2tf">
            <dt className="text-muted-foreground" data-id="element-119" data-mp="3g8t4x7vs2oju">Amount</dt>
            <dd className="font-mono text-foreground" data-id="element-120" data-mp="3bbau1by79z97">{pill.dose}</dd>
          </div>
          <div className="flex gap-1" data-id="element-121" data-mp="36by3oh84ea1v">
            <dt className="text-muted-foreground" data-id="element-122" data-mp="36awukianzxms">Per sachet</dt>
            <dd className="font-mono text-foreground" data-id="element-123" data-mp="32amo74iyn57e">{pillCountLabel(pill)}</dd>
          </div>
          <div className="flex gap-1" data-id="element-124" data-mp="1uwsxv4cozve1">
            <dt className="text-muted-foreground" data-id="element-125" data-mp="1uxufjro7rg4q">Per month</dt>
            <dd className="font-mono text-foreground" data-id="element-126" data-mp="1qvfsevdihu7n">{pill.count * PACK_DAYS}</dd>
          </div>
        </dl>
        {reasons && reasons.length > 0 && <p className="mt-2 flex flex-wrap gap-1.5" data-id="element-127" data-mp="1sd4q5taqqj5e">
            {reasons.map(r => <span key={r} className="rounded-full border border-[#f5b454]/30 px-2 py-0.5 text-[11px] text-[#f5b454]" data-id="element-128" data-mp="1xaxvkk47z94m">
                {r}
              </span>)}
          </p>}
      </div>
      <span className="hidden items-center gap-1 text-xs text-muted-foreground sm:flex" data-id="element-129" data-mp="1nbfdyabs7zfq">
        <TimingIcon className="size-3.5" data-id="element-130" data-mp="19kamhvikidgh" />
        {pill.timing}
      </span>
      {showPrice && <span className="hidden w-20 text-right font-mono text-xs text-muted-foreground sm:block" data-id="element-131" data-mp="1eddgg4r9box7">{formatAED(pill.price)}</span>}
      {onToggle && <Button variant={inPack ? 'outline' : 'secondary'} size="sm" onClick={onToggle} aria-label={inPack ? `Remove ${pill.name}` : `Add ${pill.name}`} data-id="element-132" data-mp="14msc00owjq6d">
          {inPack ? <Minus className="size-3.5" data-id="element-133" data-mp="up4dr0s380jg" /> : <Plus className="size-3.5" data-id="element-134" data-mp="unb73lhh5gbg" />}
          {inPack ? 'Remove' : 'Add'}
        </Button>}
    </li>;
}